import classNames from 'classnames'
import React from 'react'
import cl from '../classnames.scss'
import s from './subtitle.scss'
import {SubtitleProps} from './index'

export const Subtitle: React.FC<SubtitleProps> = ({dataHook, text, mobile, customColor, compact}) => (
  <h2
    className={classNames(
      cl.evSubtitlesFont,
      customColor || cl.evSubtitlesColor,
      mobile ? s.mobile : s.desktop,
      compact ? s.compact : '',
    )}
    data-hook={dataHook}
  >
    {text}
  </h2>
)
